export const PROFESSIONAL_CONTACT_TYPES = Object.freeze([
	'PHONE', 'WHATSAPP', 'TELEGRAM', 'VIBER', 'EMAIL',
	'WEBSITE', 'INSTAGRAM', 'FACEBOOK', 'VK', 'SKYPE',
])

const CONTACT_TYPES = new Set(PROFESSIONAL_CONTACT_TYPES)

export function normalizeExactReldoId(value) {
	const normalized = String(value ?? '').trim()
	return /^[1-9]\d{11}$/.test(normalized) ? normalized : null
}

export function normalizeExactDiscoveryEmail(value) {
	const normalized = String(value ?? '').trim().toLowerCase()
	if (normalized.length > 320 || /[*%_]/.test(normalized)) return null
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized) ? normalized : null
}

export function organizationProfileCapabilities(organization, actorRole) {
	return Object.freeze({
		canEditPresentation: organization?.kind === 'TEAM' && ['OWNER', 'ADMIN'].includes(actorRole),
	})
}

export function membershipProfileCapabilities({ organizationKind, actorMembershipId, actorRole, targetMembership }) {
	const self = String(actorMembershipId ?? '') === String(targetMembership?.id ?? '')
	const canGovern = organizationKind === 'PERSONAL'
		? self && actorRole === 'OWNER'
		: actorRole === 'OWNER'
			|| (actorRole === 'ADMIN' && (self || targetMembership?.role === 'MEMBER'))
	return Object.freeze({
		canEditDisplayName: canGovern,
		canEditTitle: canGovern,
		canEditAvatar: self,
		canEditContacts: self,
	})
}

export function normalizePublicContacts(contacts) {
	if (!Array.isArray(contacts) || contacts.length > 20) throw new TypeError('Invalid public contacts')
	const seen = new Set()
	return contacts.map(contact => {
		const type = String(contact?.type || '').toUpperCase()
		const value = String(contact?.value || '').trim()
		const identity = `${type}\0${value}`
		if (!CONTACT_TYPES.has(type) || !value || value.length > 500 || seen.has(identity)) {
			throw new TypeError('Invalid public contacts')
		}
		seen.add(identity)
		return { type, value }
	})
}

export function normalizeMembershipContacts(contacts) {
	return normalizePublicContacts(contacts).map((contact, index) => ({
		...contact,
		isPublic: Boolean(contacts[index]?.isPublic),
	}))
}

export function discoveryResultToOrganizationTarget(result) {
	if (!result?.organization) return null
	const organization = result.organization
	return Object.freeze({
		kind: organization.kind,
		reldoId: organization.reldoId,
		name: organization.name,
		systemLabelKey: organization.systemLabelKey,
		logoObjectKey: organization.logoObjectKey,
		publicContacts: organization.publicContacts,
		professional: result.professional,
	})
}

export function safeProfileError(error) {
	const code = error?.response?.data?.error?.code || error?.code
	const messages = {
		INVALID_DISCOVERY_QUERY: 'Введите точный 12-значный Reldo ID или корректный email.',
		ORGANIZATION_NOT_FOUND: 'Организация не найдена.',
		RATE_LIMITED: 'Слишком много запросов. Повторите позже.',
		ORGANIZATION_ACTION_FORBIDDEN: 'Недостаточно прав для изменения профиля организации.',
		PROFILE_ACTION_FORBIDDEN: 'Недостаточно прав для изменения этого профиля участника.',
		MEMBERSHIP_NOT_FOUND: 'Профиль участника больше недоступен.',
		STALE_ORGANIZATION_RESPONSE: 'Организация была переключена. Данные не применены.',
	}
	return messages[code] || 'Не удалось выполнить действие. Повторите попытку.'
}
